import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "../../utils/api";

const initialState = {
  //   token: Cookies.get(TOKEN_COOKIE) || null,
  allAdmin: null,
  loading: false,
  admin: null,
  error: null,
  editError: null,
  userData: null,
};

export const updateUserData = createAsyncThunk(
  "admin/updateUserData",
  async ({ updatedAdmin, id }, { rejectWithValue }) => {
    try {
      const { data } = await API.admin.updateAdmin(updatedAdmin, id);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllAdmin = createAsyncThunk(
  "admin/getAllAdmin",
  async (args, { rejectWithValue }) => {
    try {
      const { data } = await API.admin.getAllAdmin();
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAdminById = createAsyncThunk(
  "admin/getAdminById",
  async (args, { rejectWithValue }) => {
    try {
      const { data } = await API.admin.getAdminById();
      console.log(data);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    // logout: (state) => {
    //   Cookies.remove(TOKEN_COOKIE);
    //   state.token = null;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllAdmin.fulfilled, (state, action) => {
        state.allAdmin = action.payload;
        // console.log(state.allAdmin, "allAdmin");
        state.loading = false;
        // Cookies.set(TOKEN_COOKIE, action.payload);
      })
      .addCase(getAllAdmin.rejected, (state, action) => {
        state.error = action.payload.response;
        state.loading = false;
      })

      .addCase(getAdminById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminById.fulfilled, (state, action) => {
        // console.log("admin by id", action.payload);
        state.admin = action.payload;
        state.loading = false;
      })
      .addCase(getAdminById.rejected, (state, action) => {
        state.error = action.payload.response;
        state.loading = false;
      })

      .addCase(updateUserData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUserData.fulfilled, (state, action) => {
        state.userData = action.payload;
        // console.log(state.userData, "USer data checking");
        state.loading = false;
      })
      .addCase(updateUserData.rejected, (state, action) => {
        state.editError = action.payload.response.data;
        // console.log(state.editError, "checking the error");
        state.loading = false;
      });
  },
});

// console.log(first)
export const selectAllAdmin = (state) => state.admin.allAdmin;
export const selectAdmin = (state) => state.admin.admin;
export const selectLoading = (state) => state.admin.loading;
export const selectUserData = (state) => state.admin.userData;
export const selectEditError = (state) => state.admin.editError;

// export const { logout } = authSlice.actions;
export default adminSlice.reducer;
